export default __webpack_public_path__ + "static/media/bg-5.84e241c9.jpg";